import clsx from 'clsx'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useAppSelector } from 'src/redux/hooks'

import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import MenuIcon from '@material-ui/icons/Menu'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  menu: {},
  menuItem: {
    margin: '0.25rem 0.5rem',
  },
  dividedItem: {
    borderBottom: '1px solid black',
  },
  root: {
    marginRight: '1rem',
  },
}))

type WorkflowSelectorDropdownProps = {
  workflowTitle?: string
}
const WorkflowSelectorDropdown: React.FC<WorkflowSelectorDropdownProps> = ({ workflowTitle }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLButtonElement) | null>(null)
  const rootPath = useAppSelector((state) => state.navigation.rootPath)

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <div className={classes.root}>
      <Button variant='outlined' color='inherit' onClick={handleClick} startIcon={<MenuIcon />}>
        {workflowTitle ? workflowTitle : 'Workflows'}
      </Button>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        className={classes.menu}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          component={Link}
          to='/umibuilder/upload?entrypoint=gis'
          className={classes.menuItem}
        >
          GIS Data Preparation (GIS to UIO)
        </MenuItem>
        <MenuItem
          component={Link}
          to='/umibuilder/upload?entrypoint=uio'
          className={clsx(classes.menuItem, classes.dividedItem)}
        >
          Assign Archetypes (UIO to UMI)
        </MenuItem>
        <MenuItem
          component={Link}
          to='/analysis'
          className={clsx(classes.menuItem, classes.dividedItem)}
        >
          Results Analyzer
        </MenuItem>
        <MenuItem component={Link} to='/umibuilder/reference-library' className={classes.menuItem}>
          Build Template Library
        </MenuItem>
        <MenuItem
          component={Link}
          to='/upgrades'
          className={clsx(classes.menuItem, classes.dividedItem)}
        >
          Template Updater
        </MenuItem>
        <MenuItem
          component={Link}
          to='/project/dashboard'
          className={clsx(classes.menuItem, classes.dividedItem)}
        >
          Project Dashboard
        </MenuItem>
        <MenuItem component={Link} to='/account' className={classes.menuItem}>
          Account
        </MenuItem>
        <MenuItem component={Link} to='/account/teams' className={classes.menuItem}>
          Teams
        </MenuItem>
        <MenuItem component={Link} to='/account/projects' className={classes.menuItem}>
          Projects
        </MenuItem>
        {/* <MenuItem component={Link} to="/editTemplateLibrary" className={classes.menuItem}>Edit TemplateLibrary</MenuItem> */}
      </Menu>
    </div>
  )
}

export default WorkflowSelectorDropdown
